import React from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import Search from "../components/Recherche";

const Recherche = () => {
    return (
        <div>
            <Navigation />
            <Search />
            <Footer />
        </div>
    )
}


export default Recherche;